<template>
  <loader v-if="fetchFavoritesPending"/>
  <v-container v-else>
    <v-row>
      <v-col :cols="12">
        <h1>{{ $t('texts.favorites') }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12">
        <v-alert type="info" :value="favorites.length === 0">
          {{ $t('texts.info.noFavorites') }}
          <v-btn
            outlined color="white" small
            :to="{name: 'job.list', params: { lang: $i18n.locale }}"
          >
            {{ $t('texts.jobSearch') }}
          </v-btn>
        </v-alert>
        <job-list-item
          v-for="job in favorites"
          :job="job"
          :company="job.company"
          :key="job.id"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import JobListItem from '@/components/_templates/job/searchlist/ListItems.vue';

const { mapState: mapUserState, mapActions: mapUserActions } = createNamespacedHelpers('user');

export default {
  name: 'EmployeeFavorite',
  components: {
    JobListItem,
  },
  created() {
    this.fetchFavorites();
  },
  computed: {
    ...mapUserState([
      'fetchFavoritesPending',
      'favorites',
    ]),
  },
  methods: {
    ...mapUserActions([
      'fetchFavorites',
    ]),
  },
};
</script>
